import { WEB_COLORS } from "@/lib/constants";
import { Box, Chip, ListItem } from "@mui/material";
import { useCallback, useMemo } from "react";

export const ChipsGroup = ({
  sx,
  size,
  disabled,
  variant,
  value,
  clickable,
  name,
  onClick,
  containerSx,
  listItemSx,
  options,
  optionsKeyMap,
  sort,
}) => {
  const optionsValue = useMemo(() => {
    let opt;

    if (optionsKeyMap) {
      opt = options?.map((i) => ({
        label: i[optionsKeyMap.label],
        value: i[optionsKeyMap.value],
      }));
    } else if (typeof options?.[0] !== "object") {
      opt = options?.map((i) => ({ label: i, value: i }));
    } else {
      opt = options;
    }

    if (typeof sort === "function") return opt.sort(sort);
    else if (sort === true)
      return opt.sort((a, b) => a.label.localeCompare(b.label));

    return opt;
  }, [options, optionsKeyMap, sort]);

  const handleClick = useCallback(
    (label, value) => {
      onClick({ target: { name, label, value } });
    },
    [name, onClick]
  );


  return (
    <Box
      component="ul"
      sx={{
        display: "flex",
        flexDirection: "row",
        flexWrap: "nowrap",
        overflowX: "auto",
        width: "100%",
        pb: "4px",
        "&::-webkit-scrollbar": {
          height: 4,
        },
        "&::-webkit-scrollbar-thumb": {
          backgroundColor: "rgba(0,0,0,0.2)",
          borderRadius: 3,
        },
        gap: 1,
        ...containerSx,
      }}
    >
      {optionsValue?.map((opt) => {
        return (
          <ListItem
            key={opt.value}
            sx={{
              display: "inline-flex",
              width: "auto",
              p: 0,
              ...listItemSx,
            }}
          >
            <Chip
              sx={{
                ...sx,
                ...(opt.value === value
                  ? {
                      bgcolor: WEB_COLORS.primary,
                      color: WEB_COLORS.pale,
                      "&:hover": {
                        bgcolor: WEB_COLORS.primary,
                      },
                    }
                  : {}),
              }}
              value={opt.value}
              skipFocusWhenDisabled
              size={size}
              disabled={disabled}
              label={opt.label}
              clickable={clickable}
              variant={variant}
              onClick={() => handleClick(opt.label, opt.value)}
            />
          </ListItem>
        );
      })}
    </Box>
  );
};
